import EduExp from './eduExp'
export default EduExp
